export enum CaseDetailsSources {
	SdsAsSecondarySurgeon = 'SdsAsSecondarySurgeon',
}

export interface CaseDetailsPageState {
	from?: CaseDetailsSources;
}
